import { z } from "zod";

export enum ETotalMetricConsumption {
  TOTAL_DEVICE_CONSUMPTION = "TOTAL_DEVICE_CONSUMPTION",
  TOTAL_DSO_CONSUMPTION = "TOTAL_DSO_CONSUMPTION",
  TOTAL_DSO_CONSUMPTION_EVOLUTION = "TOTAL_DSO_CONSUMPTION_EVOLUTION",
  TOTAL_DSO_CONSUMPTION_PRICE = "TOTAL_DSO_CONSUMPTION_PRICE",
}

export enum ECurveConsumption {
  DEVICE_CONSUMPTION_DETAILED_CURVE = "DEVICE_CONSUMPTION_DETAILED_CURVE",
  DSO_CONSUMPTION_DETAILED_CURVE = "DSO_CONSUMPTION_DETAILED_CURVE",
}

export enum EColumnM2Consumption {
  AREA_CONSUMPTION = "AREA_CONSUMPTION",
}

export enum EColumnPeriodComparisonConsumption {
  LAST_PERIOD_CONSUMPTION = "LAST_PERIOD_CONSUMPTION",
  CURRENT_PERIOD_CONSUMPTION = "CURRENT_PERIOD_CONSUMPTION",
}

export enum EConsumptionDistribution {
  DEVICES_CONSUMPTION_DISTRIBUTION = "DEVICES_CONSUMPTION_DISTRIBUTION",
}

export enum EYearConsumption {
  YEAR_CONSUMPTION = "YEAR_CONSUMPTION",
}

export const totalMetricConsumptionSchema = z.nativeEnum(ETotalMetricConsumption);
export const curveConsumptionSchema = z.nativeEnum(ECurveConsumption);
export type TMetricConsumption = ETotalMetricConsumption | ECurveConsumption;
